import { gql } from "lib/apolloClient";
import { resourceBankItemDetails } from "./ResourceBankFragments";

export const getResourceListQuery = gql`
  query getResourceList(
    $filters: ResourceBankFiltersInput!
    $stateInformation: String
  ) {
    platform {
      resourceList: resourceBankSearchResult(
        filters: $filters
        stateInformation: $stateInformation
      ) {
        resources: resourceBankResultData {
          mediaType
          thumbURL
          title
          url
          source
          downloadUrl
          author {
            userName
            firstName
            lastName
            imageUrl
          }
          extra {
            misc
          }
        }
        stateInformation
        filters {
          searchText
          count
          facets
          selected
        }
        isMore
      }
    }
  }
`;

export const getResourceListQueryV2 = gql`
  query getResourceListV2($input: ResourceBankInput!) {
    platform {
      resourceBankSearchResultV2(input: $input) {
        edges {
          node {
            ...resourceBankItem
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        errorMessage
      }
    }
  }
  ${resourceBankItemDetails.resourceBankItem}
`;
